import { useContext, useEffect, useState } from 'react';
import '../style/pages/welcome.css';
import { Link } from 'react-router-dom';
import BtnsManger from '../components/mainPage/btnsManger';
import { auth } from '../context/auth';
import PosIcon from '../docs/light/point-of-sale.png';
import WebSiteIcon from '../docs/light/website.png';
import { useTranslation } from 'react-i18next';

export default function Welcome() {
    const {ActivEmp} = useContext(auth);
    const [Role, setRole] = useState('');
    const { t } = useTranslation();
    useEffect(() => {
        if(ActivEmp.role === 'manager') {
            setRole(t("jb:manager"));
        }
        else if(ActivEmp.role === 'cashier' || ActivEmp.role === 'delivery') {
            setRole(t("jb:cashier"));
        }
        else {
            setRole('')
        }
    },[ActivEmp])
    return (
        <div className='welcome flex flex-center-center'>
            <div className='parent'>
                <div>
                    <h1>{Role} {ActivEmp.name}</h1>
                    <p>{t("common:code")}: #<span className='text-weight-bold'>{ActivEmp.code}</span></p>
                </div>
                <h2>{t("common:welcomeText.head")}</h2>
                <p>{t("common:welcomeText.body")}</p>
                <div className='parent-btns flex flex-center-center'>
                    <div className='btns'>
                        <Link className='flex flex-center-center' to={'/pos'}>
                            <img alt='pos' src={PosIcon} />
                            <h6>{t("sections:POS.label")}</h6>
                        </Link>
                        {ActivEmp.role === 'manager' && <BtnsManger />}
                        <a href='/' className='flex flex-center-center'>
                            <img alt='pos' src={WebSiteIcon} />
                            <h6>{t("sections:website")}</h6>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}